module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "partnum",
    attrs: {
      "id": "p1"
    }
  }, [_c('a', {
    attrs: {
      "id": "pg10"
    }
  }), _c('a', {
    attrs: {
      "id": "pg11"
    }
  }, [_vm._v("I.")])]), _c('a', {
    attrs: {
      "id": "pg11"
    }
  }, [_c('p', {
    staticClass: "parttit",
    attrs: {
      "id": "p1_1"
    }
  }, [_vm._v("Disasters and Shipwrecks")]), _vm._v(" "), _c('p', {
    staticClass: "lev1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UST A")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOUGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Great disasters have taken place throughout recorded history. Some disasters are caused by human intervention and some by human negligence. From the time of Noah and the biblical flood and likely long before, natural disasters have been happening and will continue until the end of time. Natural and man-made disasters are on the rise at an alarming rate. In fact, it’s possible that a natural disaster will bring the end of time. Consider Revelations 6:12–13, “I looked when He opened the sixth seal and behold there was a great earthquake. And the stars of Heaven fell to the earth”; and 10:13, “In the same hour there was a great earthquake and a tenth of the city fell. In the earthquake 7,000 people were killed.” Is the Maker trying to tell us something?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A "), _c('i', [_vm._v("New York Times")]), _vm._v(" article said that humanity has an extraordinary talent for causing catastrophes. We are even likely, as many have suggested over the past century, to be responsible for the coming apocalypse.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Natural disasters are sudden and extreme events caused by environmental factors, such as earthquakes, volcanic eruptions, tornadoes, hurricanes and floods.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Human-caused disasters include train wrecks, fires, plane crashes and explosions. Most man-made disasters are caused by human error. On April 15, 1912, the RMS "), _c('i', [_vm._v("Titanic")]), _vm._v(", a British passenger liner, sank in the north Atlantic Ocean after colliding with an iceberg, resulting in the deaths of 1,500 passengers and crew. On February 1, 2003, the space shuttle "), _c('i', [_vm._v("Columbia")]), _vm._v(" broke apart while reentering the atmosphere over Texas, killing all seven crew members.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "pg11"
    }
  }), _c('a', {
    attrs: {
      "id": "pg12"
    }
  }, [_c('i', [_vm._v("Webster’s New World Dictionary")]), _vm._v(" defines "), _c('i', [_vm._v("disaster")]), _vm._v(" as “an event causing great harm or damage.”")])]), _c('a', {
    attrs: {
      "id": "pg12"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Can the increase in natural disasters be a warning of things to come? What comes next? How will we handle it?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70908274","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Part01.vue
// module id = 72
// module chunks = 0